import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import css from './CalendarManagerRow.scss';
import Icon from 'SF/MaterialIcon';
import { isEmptyString } from 'utils/text';
import CalendarLockIcon from 'common/CalendarLockIcon';
import { SFEntityID } from 'utils/types';
import { pressedEnterOrSpace } from 'utils/accessibility';

const CalendarManagerRow = (props) => {
    const getCalendarLocking = () => {
        if (!props.showCalendarAdminInformation) return null;
        if (!props.calendarAdministrator) return <Table.Cell></Table.Cell>;
        return (
            <Table.Cell collapsing className={css['calendar-lock']}><CalendarLockIcon /></Table.Cell>
        );
    };
    
    const getEmail = () => {
        if (!isEmptyString(props.email))
            return <><br /><a href={`mailto:${props.email}`} data-testid='email'>{props.email}</a></>
    };
    
    const getDelete = () => {
        if (props.calendarAdministrator) return null;
        if (props.manualRelationship) return (
            <a aria-label={`Delete ${props.fullName}`}
               onClick={() => props.deleteCalendarManager(props.entityId)}
               onKeyDown={(e) => {
                   if (pressedEnterOrSpace(e)) {
                       e.preventDefault();
                       props.deleteCalendarManager(props.entityId);
                   }
               }}
               role="button"
               tabIndex="0">
                <Icon className={css['cancel']} icon="cancel" />
            </a>
        );
        return (
            <a aria-label={`Info for ${props.fullName}`}
               onClick={props.calendarManagerInfo}
               onKeyDown={(e) => {
                   if (pressedEnterOrSpace(e)) {
                       e.preventDefault();
                       props.calendarManagerInfo();
                   }
               }}
               role="button"
               tabIndex="0">
                <Icon className={css['info']} icon="info" />
            </a>
        );
    };
    
    return (
        <Table.Row className={css['manager-row']} data-testid={`managerRow${props.lastName.replace(/\s+/g, '')}`}>
            {getCalendarLocking()}
            <Table.Cell className={css['manager-info']}>
                {props.fullName}
                {getEmail()}
            </Table.Cell>
            <Table.Cell collapsing className={css['tools']}>{getDelete()}</Table.Cell>
        </Table.Row>
    );
};

CalendarManagerRow.propTypes = {
    calendarAdministrator: PropTypes.bool,
    calendarManagerInfo: PropTypes.func,
    deleteCalendarManager: PropTypes.func,
    email: PropTypes.string,
    entityId: SFEntityID.isRequired,
    fullName: PropTypes.string.isRequired,
    lastName: PropTypes.string,
    manualRelationship: PropTypes.bool,
    showCalendarAdminInformation: PropTypes.bool
};

export default CalendarManagerRow;
